import userReducer from './user.js'
import localeReducer from './locale.js'
import coursesReducer from './courses.js'
import courseReducer from './course.js'

const initialState = {}

export default function rootReducer(state = initialState, action) {
  const ret = {
    ...initialState,
    locale: localeReducer(state.locale, action),
    user: userReducer(state.user, action),
    courses: coursesReducer(state.courses, action),
    course: courseReducer(state.course, action),
  }
  return ret
}
